import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/listing-promotion-ebay';

export default function Example() {
  return (
    <>
      <Head>
        <title>A Beginner’s Guide to eBay Listing Promotions</title>
        <meta
          name='description'
          content='What are Promoted listings on eBay? Explore the options you have in boosting your listings for increased chances of sales – plus practical tips to improve the quality of your listings to appear better on searches and attract more buyers.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/listing-promotion-ebay' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/listing-promotion-ebay' />
        <meta property='og:title' content='A Beginner’s Guide to eBay Listing Promotions' />
        <meta
          property='og:description'
          content='What are Promoted listings on eBay? Explore the options you have in boosting your listings for increased chances of sales – plus practical tips to improve the quality of your listings to appear better on searches and attract more buyers.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
